import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

export type GeoData = {
  currency: string;
  timezone: string;
};

export const fetchMyGeoLocation = createAsyncThunk<GeoData>(
  "getmygeolocation",
  async () => {
    const res = await axios.get("https://ipapi.co/json/");
    localStorage.setItem("currency", res.data.currency);
    localStorage.setItem("timezone", res.data.timezone);
    return {
      currency: res.data.currency,
      timezone: res.data.timezone,
    };
  }
);

type GeoState = {
  data: GeoData;
  loading: boolean;
  error: string | null;
};

const initialState: GeoState = {
  data: {
    currency: localStorage.getItem("currency") || "",
    timezone: localStorage.getItem("timezone") || "",
  },
  loading: false,
  error: null,
};

const geolocationSlice = createSlice({
  name: "geolocation",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyGeoLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchMyGeoLocation.fulfilled,
        (state, action: PayloadAction<GeoData>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchMyGeoLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Unknown error";
      });
  },
});

export default geolocationSlice.reducer;
